import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_z4cmjuda3k: FaireBrandEntity = {
  token: "b_z4cmjuda3k",
  type: "brand",
  name: "Solar Eclipse",
  avatarUrl:
    "https://cdn.faire.com/fastly/b07a3b4d0b99fb107b7f3350f68baca8e6965218bbf4a47f6f013587f0807d32.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f45aa4a7f61c62558f3b6d0517f64446e28b4e4b5a76f92c1df26e6af5586aef.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b07a3b4d0b99fb107b7f3350f68baca8e6965218bbf4a47f6f013587f0807d32.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f45aa4a7f61c62558f3b6d0517f64446e28b4e4b5a76f92c1df26e6af5586aef.png",
  location: "New York City, NY, USA",
  minimumOrderDollars: 205,
  rating: 4.9,
  reviewCount: 245,
  isInsider: true,
  description:
    "Solar Eclipse is a contemporary, hand-crafted lifestyle brand designed in New York City, created from an interest in reimagining everyday objects. Rooted in nostalgia and everyday ritual, the brand transforms functional accessories and homeware into expressive, intentional objects. \n\nCrafted in small batches, Solar Eclipse designs elevate daily routines and are meant to be worn, used, and lived with for years to come. Each piece is handmade with the finest sustainable materials including signature biodegradable acetate.\n\nWe have strict global copyright protection for our designs, making them a unique and special item, that you cannot get anywhere else.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:03.499Z",
    importedBy: "entity-db-cli",
  },
};
